var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25629",
    "data-name": "Group 25629",
    transform: "translate(-559 -216)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14183",
    "data-name": "Rectangle 14183",
    width: 26,
    height: 26,
    rx: 5,
    transform: "translate(559 216)",
    fill: "#533ffb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_25628",
    "data-name": "Group 25628"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icons8-close",
    d: "M4.53,12.687,3.47,11.626,11.626,3.47,12.687,4.53Z",
    transform: "translate(563.922 220.922)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icons8-close-2",
    "data-name": "icons8-close",
    d: "M11.626,12.687l1.061-1.061L4.53,3.47,3.47,4.53Z",
    transform: "translate(563.922 220.922)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterCross);
export default __webpack_public_path__ + "static/media/filter-cross.0270978ad6dfceacdd768188f1803b7e.svg";
export { ForwardRef as ReactComponent };